/**
 * Marcel – Vidde/Lengde-velgar for jeans
 * Deler storleikar som "29/32" i to knapperader (Vidde + Lengde).
 * Slår berre inn når ALLE storleikar er på forma NN/30, NN/32 eller NN/34
 * og produktet har minst to ulike lengder. Produktdata blir ikkje endra:
 * skriptet styrer temaets eigne (skjulte) storleiksknappar i bakgrunnen.
 */
(function () {
  if (window.__wlSplitInit) return;
  window.__wlSplitInit = true;

  var RE = /^(\d{2})\/(30|32|34)$/;
  var state = {};
  var uid = 0;

  function num(a, b) { return Number(a) - Number(b); }

  function injectStyle() {
    if (document.getElementById('wl-split-style')) return;
    var s = document.createElement('style');
    s.id = 'wl-split-style';
    s.textContent =
      '.wl-hidden{display:none!important}' +
      '.wl-split{margin-bottom:8px}' +
      '.wl-split .wl-row{margin-bottom:18px}' +
      '.wl-split .wl-head{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
      '.wl-split .opt-btn:disabled+.opt-label{opacity:.3;cursor:not-allowed;text-decoration:line-through}' +
      '.wl-split .wl-hint{font-size:14px;color:#A33A2B;margin:0;min-height:0}' +
      '.wl-split .wl-hint:empty{display:none}' +
      '.wl-split .wl-row--missing .label{color:#A33A2B}' +
      '.wl-split .wl-row--missing .option-selector__btns{animation:wl-shake .35s ease}' +
      '@keyframes wl-shake{0%,100%{transform:none}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}' +
      '.wl-needs-size .shopify-payment-button,.wl-needs-size shopify-accelerated-checkout{display:none!important}';
    document.head.appendChild(s);
  }

  function rowHtml(type, label, values, id) {
    var h = '<div class="wl-row" data-wl-row="' + type + '">' +
      '<div class="wl-head"><span class="label">' + label + '</span></div>' +
      '<div class="option-selector__btns flex flex-wrap">';
    values.forEach(function (v) {
      var iid = 'wl-' + id + '-' + type + '-' + v;
      h += '<input type="radio" class="opt-btn visually-hidden focus-label" form="wl-none"' +
        ' name="wl-' + id + '-' + type + '" id="' + iid + '" value="' + v + '" data-wl="' + type + '">' +
        '<label for="' + iid + '" class="opt-label opt-label--btn btn relative text-center">' +
        '<span class="js-value">' + v + '</span></label>';
    });
    return h + '</div></div>';
  }

  function sectionOf(picker) {
    return picker.closest('.js-quickbuy') || picker.closest('.cc-featured-product') || picker.closest('.shopify-section');
  }

  function setBlocked(picker, blocked) {
    var sec = sectionOf(picker);
    if (sec) sec.classList.toggle('wl-needs-size', blocked);
  }

  // Stopp kjøp til vidde og lengde er valt, og vis kva som manglar
  function guard(e) {
    var btn = e.type === 'submit' ? e.target.querySelector('[name="add"]') : e.target.closest && e.target.closest('[name="add"]');
    if (!btn) return;
    var sec = btn.closest('.js-quickbuy') || btn.closest('.cc-featured-product') || btn.closest('.shopify-section');
    var wrap = sec && sec.querySelector('.wl-split');
    if (!wrap || !wrap.__wlState || wrap.__wlState.chosen) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (e.type === 'click') wrap.__wlShowMissing();
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);

  function enhance(picker) {
    if (picker.querySelector('.wl-split')) return;
    if (picker.dataset.optionCount !== '1') return;
    var fs = picker.querySelector('fieldset.option-selector[data-selector-type="listed"]');
    if (!fs) return;
    var inputs = Array.prototype.slice.call(fs.querySelectorAll('input.js-option'));
    if (inputs.length < 2) return;

    var combos = {};
    var ws = {};
    var ls = {};
    for (var i = 0; i < inputs.length; i++) {
      var m = RE.exec(String(inputs[i].value).trim());
      if (!m) return; // Alle storleikar må vere NN/30, NN/32 eller NN/34
      combos[m[1] + '/' + m[2]] = inputs[i];
      ws[m[1]] = 1;
      ls[m[2]] = 1;
    }
    var wList = Object.keys(ws).sort(num);
    var lList = Object.keys(ls).sort(num);
    if (lList.length < 2) return; // Berre éi lengd: vis som vanleg

    injectStyle();

    var isMain = !picker.closest('.js-quickbuy') && !picker.closest('.cc-featured-product');
    var key = (picker.dataset.url || '') + (isMain ? '|main' : '|other');
    var st = state[key];
    var checked = fs.querySelector('input.js-option:checked');
    if (!st) {
      st = state[key] = { w: null, l: null, chosen: false };
      if (isMain && checked && new URLSearchParams(window.location.search).has('variant')) {
        st.chosen = true;
      }
    }
    if (st.chosen && checked) {
      var cm = RE.exec(String(checked.value).trim());
      if (cm) { st.w = cm[1]; st.l = cm[2]; }
    }

    uid += 1;
    var wrap = document.createElement('div');
    wrap.className = 'wl-split';
    wrap.innerHTML =
      rowHtml('w', 'Vidde (W)', wList, uid) +
      rowHtml('l', 'Lengde (L)', lList, uid) +
      '<p class="wl-hint"></p>';
    fs.parentNode.insertBefore(wrap, fs.nextSibling);
    fs.classList.add('wl-hidden');

    // Flytt eventuell storleiksguide-lenkje inn i Vidde-overskrifta
    var chart = fs.querySelector('.flex.justify-between > :not(legend)');
    if (chart) wrap.querySelector('.wl-head').appendChild(chart);

    function isAvail(inp) { return inp && !inp.classList.contains('is-unavailable'); }

    function render() {
      wrap.querySelectorAll('input[data-wl="w"]').forEach(function (r) {
        var any = lList.some(function (l) { return isAvail(combos[r.value + '/' + l]); });
        r.classList.toggle('is-unavailable', !any);
        r.checked = r.value === st.w;
      });
      wrap.querySelectorAll('input[data-wl="l"]').forEach(function (r) {
        var missing = false;
        var avail;
        if (st.w) {
          var c = combos[st.w + '/' + r.value];
          missing = !c;
          avail = isAvail(c);
        } else {
          avail = wList.some(function (w) { return isAvail(combos[w + '/' + r.value]); });
        }
        r.disabled = missing;
        r.classList.toggle('is-unavailable', !avail && !missing);
        r.checked = r.value === st.l;
      });
      wrap.querySelectorAll('.wl-row--missing').forEach(function (row) {
        var type = row.dataset.wlRow;
        if ((type === 'w' && st.w) || (type === 'l' && st.l)) row.classList.remove('wl-row--missing');
      });
      var hint = wrap.querySelector('.wl-hint');
      if (hint.textContent) {
        if (!st.w) hint.textContent = 'Velg vidde';
        else if (!st.l) hint.textContent = 'Velg lengde';
        else hint.textContent = '';
      }
      setBlocked(picker, !st.chosen);
    }

    wrap.__wlState = st;
    wrap.__wlShowMissing = function () {
      var missing = !st.w ? 'w' : 'l';
      var row = wrap.querySelector('[data-wl-row="' + missing + '"]');
      wrap.querySelector('.wl-hint').textContent = missing === 'w' ? 'Velg vidde' : 'Velg lengde';
      row.classList.remove('wl-row--missing');
      void row.offsetWidth; // start animasjonen på nytt
      row.classList.add('wl-row--missing');
      var r = row.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    wrap.addEventListener('change', function (e) {
      e.stopPropagation(); // Ikkje la temaet tru at dette er eit variantbyte
      var t = e.target;
      if (!t || !t.dataset.wl) return;
      if (t.dataset.wl === 'w') {
        st.w = t.value;
        if (st.l && !combos[st.w + '/' + st.l]) st.l = null;
      } else {
        st.l = t.value;
      }
      var target = st.w && st.l ? combos[st.w + '/' + st.l] : null;
      st.chosen = !!target;
      render();
      if (target) {
        if (!target.checked) {
          target.checked = true;
          target.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { noFocus: true } }));
        }
      }
    });

    render();
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll('variant-picker').forEach(function (p) {
      try { enhance(p); } catch (err) { /* feil her skal aldri stoppe kjøp */ }
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(scan, 30);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
}());
